/* @ds-bundle: {"format":4,"namespace":"Modernist_modern","components":[],"sourceHashes":{},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.Modernist_modern = window.Modernist_modern || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

})();
